// extracted by mini-css-extract-plugin
module.exports = {"primary":"Text_primary__dgNcs","secondary":"Text_secondary__3B7PS","tertiary":"Text_tertiary__2wg7k"};